import { useEffect } from "react"
import { useFormikContext } from "formik"

import { useContext } from "react"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"

export default function OrganizationId({ field, index, enterprise_id }) {
  const formik = useFormikContext()
  const userCtx = useContext(UserContext)

  enterprise_id = userCtx.checkOrgPropWithFallback("enterprise_id", enterprise_id, "TypeHidden.OrganizationId")

  useEffect(() => {
    return formik.setFieldValue(field.field_name, enterprise_id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
